import { Component, ChangeDetectionStrategy, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { TilesComponent } from '../../tiles.shared.component';

@Component({
    selector: 'shared-tile-for-reorder-product-item',
    templateUrl: './tile-for-reorder-product-item.shared.component.html',
    styleUrls: ['./tile-for-reorder-product-item.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileForReorderProductItemComponent extends TilesComponent implements OnInit {
    public isMenuFlow: boolean = false;
    public title: string;
    public total: number;
    public description: string;

    @Input() public bottomPadding: boolean = false;
    @Input() public orderItem: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended;
    @Input() public disabled: boolean;
    @Input() public selectable: boolean;
    @Input() public selected: boolean;
    @Output() public onSelected: EventEmitter<{ event: Event; item: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended; }> = new EventEmitter();
    @Output() public onDeselected: EventEmitter<{ event: Event; item: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended; }> = new EventEmitter();

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) {
        super(changeDetectorRef, controllers);
    }

    ngOnInit(): void {
        this.isMenuFlow = !!this.orderItem?.MenuFlowId;
        this.title = `${this.orderItem?.Quantity}x ${this.orderItem?.DisplayName}`;

        this.total = this.orderItem?.Quantity * (this.isMenuFlow ?
            (this.orderItem as State.ICartMenuFlowExtended)?.UnitTotalValue :
            (this.orderItem as State.ICartSimpleItemExtended)?.UnitPrice);

        this.description = (this.orderItem as State.ICartMenuFlowExtended)?.DisplayDescription;

        this.disabled = this.orderItem?._IsDisabled;

        if (this.disabled === false && this.selectable === undefined) {
            this.selectable = true;
        }
    }

    public handleSelected($event: Event): void {
        this.onSelected.emit({ event: $event, item: this.orderItem as State.ICartMenuFlowExtended | State.ICartSimpleItemExtended });
    }

    public handleDeselected($event: Event): void {
        this.onDeselected.emit({ event: $event, item: this.orderItem as State.ICartMenuFlowExtended | State.ICartSimpleItemExtended });
    }
}
